import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimezoneSelect from "react-timezone-select";

const Calendar = ({ events, selectedDate, handelOnDayClicking, handleViewTypeChange, timezone, handleTimezoneChange }) => {
  const [hasPrevWeekEvents, setHasPrevWeekEvents] = useState(false);
  const [hasNextWeekEvents, setHasNextWeekEvents] = useState(false);
  const [hasPrevMonthEvents, setHasPrevMonthEvents] = useState(false);
  const [hasNextMonthEvents, setHasNextMonthEvents] = useState(false);

  // Utility function to check if events exist in a given range
  const hasEventsInRange = (startDate, endDate) => {
    return events.some(event => {
      const eventDate = new Date(event.startTime);
      return eventDate >= startDate && eventDate < endDate;
    });
  };

  // Function to update event indicators for navigation buttons
  const updateEventIndicators = () => {
    const now = selectedDate;

    const prevWeekStart = new Date(now);
    prevWeekStart.setDate(now.getDate() - 7);
    const prevWeekEnd = new Date(now);

    const nextWeekStart = new Date(now);
    nextWeekStart.setDate(now.getDate() + 1);
    const nextWeekEnd = new Date(nextWeekStart);
    nextWeekEnd.setDate(nextWeekStart.getDate() + 7);

    const prevMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const prevMonthEnd = new Date(now.getFullYear(), now.getMonth(), 1);

    const nextMonthStart = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    const nextMonthEnd = new Date(nextMonthStart.getFullYear(), nextMonthStart.getMonth() + 1, 1);

    setHasPrevWeekEvents(hasEventsInRange(prevWeekStart, prevWeekEnd));
    setHasNextWeekEvents(hasEventsInRange(nextWeekStart, nextWeekEnd));
    setHasPrevMonthEvents(hasEventsInRange(prevMonthStart, prevMonthEnd));
    setHasNextMonthEvents(hasEventsInRange(nextMonthStart, nextMonthEnd));
  };

  // Update indicators whenever `selectedDate` or `events` change
  useEffect(() => {
    updateEventIndicators();
  }, [selectedDate, events]);

  const CustomInput = ({ value, onClick }) => (
    <button className="customDatePickerInput" onClick={onClick}>
      {value}
    </button>
  );

  const navigateMonth = (direction) => {
    const newDate = new Date(selectedDate);
    if (direction === 'left') {
      newDate.setMonth(newDate.getMonth() - 1);
    } else if (direction === 'right') {
      newDate.setMonth(newDate.getMonth() + 1);
    }
    handelOnDayClicking(newDate);
  };

  const navigateWeek = (direction) => {
    const newDate = new Date(selectedDate);
    if (direction === 'left') {
      newDate.setDate(newDate.getDate() - 7);
    } else if (direction === 'right') {
      newDate.setDate(newDate.getDate() + 7);
    }
    handelOnDayClicking(newDate);
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px", justifyContent: "space-between" }}>
        <div className='customDatePicker'>
          <button className="event-close-button" style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", outline: "none"}} onClick={() => navigateMonth('left')}>
            <i className="fa-solid fa-angles-left"></i>
            {hasPrevMonthEvents ? <i class="fa-solid fa-circle" style={{position: "fixed", fontSize: "8px", color: "#365561", marginTop: "-20px"}}></i> : null}
          </button>
          <button className="event-close-button" style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", outline: "none"}} onClick={() => navigateWeek('left')}>
            <i className="fa-solid fa-angle-left"></i>
            {hasPrevWeekEvents ? <i class="fa-solid fa-circle" style={{position: "fixed", fontSize: "8px", color: "#365561", marginTop: "-20px"}}></i> : null}
          </button>
          <div style={{ margin: "5px" }}>
            <DatePicker
              selected={selectedDate}
              onChange={handelOnDayClicking}
              dateFormat="dd MMMM yyyy"
              customInput={<CustomInput />}
            />
          </div>
          <button className="event-close-button" style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", outline: "none"}} onClick={() => navigateWeek('right')}>
            <i className="fa-solid fa-angle-right"></i>
            {hasNextMonthEvents ? <i class="fa-solid fa-circle" style={{position: "fixed", fontSize: "8px", color: "#365561", marginTop: "-20px"}}></i> : null}
          </button>
          <button className="event-close-button" style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", outline: "none"}} onClick={() => navigateMonth('right')}>
            <i className="fa-solid fa-angles-right"></i>
            {hasNextWeekEvents ? <i class="fa-solid fa-circle" style={{position: "fixed", fontSize: "8px", color: "#365561", marginTop: "-20px"}}></i> : null}
          </button>
          <button className="event-close-button" onClick={() => handleViewTypeChange("Week")}>Weekly</button>
          <button className="event-close-button" onClick={() => handleViewTypeChange("Month")}>Monthly</button>
        </div>
        <div style={{ right: "100" }}>
          <TimezoneSelect value={timezone} onChange={(e) => handleTimezoneChange(e)} />
        </div>
      </div>
    </>
  );
};

export default Calendar;
